var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('paginated-table',{attrs:{"id":"admin-loans-table","columns":_vm.columns,"extra-filters":_vm.extraFilters,"load-relations":[
      'loanable',
      'loanable.merged_user_roles',
      'loanable.active_incidents',
      'community',
    ],"endpoint":"loans","fetch-params":{ for: 'admin' },"label":_vm.$tc('loans.model_name', 2),"sync-filters-with-url":"","show-action-column":false,"row-link":""},scopedSlots:_vm._u([{key:"cell(status)",fn:function({ item }){return [_c('loan-status',{attrs:{"item":item,"small":""}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }